// Overviews: pagination and search
export function appDataReducerPaginationAndSearch(rawMeta) {
    rawMeta.limit = parseInt(rawMeta.limit, 10);
    rawMeta.offset = parseInt(rawMeta.offset, 10);

    const meta = {
        search: rawMeta.search,
        totalResults: rawMeta.total,
        page: Math.ceil(rawMeta.offset / rawMeta.limit + 1),
    };

    return meta;
}
